import React from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import AlertsManagement from './AlertsManagement';

const AlertsPage: React.FC = () => {
  return (
    <DashboardLayout>
      <AlertsManagement />
    </DashboardLayout>
  );
};

export default AlertsPage;
